import { clearApiKey } from "../../utils/apiKey";
import { Component } from "react";
import { Link } from "react-router-dom";

class Unauthorized extends Component {
  clearLocalStorage = () => {
    clearApiKey();
    localStorage.clear();
  };
  render() {
    return (
      <>
        <div className="page401">
          <p> خطای احراز هویت لطفا دوباره وارد شوید !</p>
          <button className="btn401" onClick={() => this.clearLocalStorage()}>
            <Link to={"/"}>ورود</Link>
          </button>
        </div>
      </>
    );
  }
}

export default Unauthorized;
